import Index from "../components/sections/Index";
import AppRedirect from "../components/sections/download/AppRedirect";

export const privateRoute = [
    {
        path: "/",
        element: <Index />,
    },
    {
        path: "/download",
        element: <AppRedirect />,
    },
]